import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import Footer from "../Footer";
import { myBreadCrumbs2L } from '../Portafolio/Handlers/Breadcrumbs';
import banner from "../../images/asesorias.jpg";
import { useStore } from "../../app/stores/store";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { getCATCursos } from "../../app/models/CATCursos";
import { RegionalBannerCentral } from '../Portafolio/Handlers/RegionalBannerCentral';
import bannerAseso from "../Portafolio/src/imgs/page_headers/asesorias.png";
import img1 from "../Portafolio/src/imgs/page_headers/1.png";
import img2 from "../Portafolio/src/imgs/page_headers/2.png";
import img3 from "../Portafolio/src/imgs/page_headers/3.png";
import img4 from "../Portafolio/src/imgs/page_headers/4.png";
import { Botonera } from '../Portafolio/helpers/botonera';
import { BuscadorComponent } from "../Portafolio/BuscadorCursos/BuscadorComponent";
import { FiltroCardsCertificados, FiltroCardsCursos } from "../Portafolio/Handlers/FiltroCursos";
import { AnchorTabsCategories } from "../Portafolio/Handlers/AnchorTabsCategories";
import { Col, Container, Row } from "react-bootstrap";
import 'font-awesome/css/font-awesome.min.css';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

interface ImageCardProps {
  image: string;
  title: string;
}
const ImageCard: React.FC<ImageCardProps> = ({ image, title }) => {
  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden w-64">
      <img src={image} alt={title} className="w-full h-40 object-cover max-w-full" />
      <div className="p-4 text-center">
        <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
      </div>
    </div>
  );
};
const loadImage = (imageName: any) =>
  require(`../../images/${imageName}`).default;
export default observer(function Asesoria() {
  const {
    userStore: { },
  } = useStore();
  const { CATCursosStore } = useStore();
  const { loadCATCursosByDir, CATCursosRegistry } = CATCursosStore;
  
  function BasicExample() {
    return (
      <Card style={{ width: '18rem', textAlign:'center', margin: '10px', borderRadius:'12px'}}>
        <Card.Img variant="top" src={img1} style={{borderRadius:'12px 12px 0px 0px'}}/>
        <Card.Body style={{ textAlign: 'center' }}>
          <Card.Title>Asistencia Técnica en Adquisiciones Públicas</Card.Title>
          <Card.Text>           
          </Card.Text>          
        </Card.Body>
        <div><Button  variant="primary" style={{ width: '80%', marginBottom: '15px' }}  onClick={() => window.open("https://inap.gob.gt/files/a1.pdf", "_blank")}>Ver programa</Button></div>   
      </Card>
    );
  }
  function BasicExample1() {
    return (
      <Card style={{ width: '18rem', textAlign:'center', margin: '10px', borderRadius:'12px'}}>
        <Card.Img variant="top" src={img2} style={{borderRadius:'12px 12px 0px 0px'}}/>
        <Card.Body style={{ textAlign: 'center' }}>
          <Card.Title>Asistencia Técnica para la elaboración de Manuales Administrativos (Procedimientos)</Card.Title>
          <Card.Text>           
          </Card.Text>          
        </Card.Body>
        <div><Button  variant="primary" style={{ width: '80%', marginBottom: '15px' }}  onClick={() => window.open("https://inap.gob.gt/files/a2.pdf", "_blank")}>Ver programa</Button></div>   
      </Card>
    );
  }
  function BasicExample2() {
    return (
      <Card style={{ width: '18rem', textAlign:'center', margin: '10px', borderRadius:'12px'}}>
        <Card.Img variant="top" src={img3} style={{borderRadius:'12px 12px 0px 0px'}}/>
        <Card.Body style={{ textAlign: 'center' }}>
          <Card.Title>Asistencia Técnica Municipal Formulación de una Política para el mojoramiento de la generación y recacudación de ingresos propios</Card.Title>
          <Card.Text>           
          </Card.Text>        
        </Card.Body>
        <div><Button  variant="primary" style={{ width: '80%', marginBottom: '15px' }}  onClick={() => window.open("https://inap.gob.gt/files/a3.pdf", "_blank")}>Ver programa</Button></div>      
      </Card>
    );
  }
  function BasicExample3() {
    return (
      <Card style={{ width: '18rem', textAlign:'center', margin: '10px', borderRadius:'12px'}}>
        <Card.Img variant="top" src={img4} style={{borderRadius:'12px 12px 0px 0px'}}/>
        <Card.Body style={{ textAlign: 'center' }}>
          <Card.Title>Asistencia Técnica Traslado del compendio de herramientas para la gestión municipal</Card.Title>
          <Card.Text>           
          </Card.Text>         
        </Card.Body>
        <div><Button  variant="primary" style={{ width: '80%', marginBottom: '15px' }}  onClick={() => window.open("https://inap.gob.gt/files/a4.pdf", "_blank")}>Ver programa</Button></div>
      </Card>
    );
  }  
  useEffect(() => {
    if (CATCursosRegistry.size <= 1) {
      loadCATCursosByDir("1444", "211");
    }
  }, [CATCursosRegistry.size, loadCATCursosByDir]);
  if (CATCursosStore.loadingInitial)
    return <LoadingComponent content="Cargando datos.." />;

  const items = [
      { id: 1, icon: 'fa-circle', texto: 'Contar con un efoque práctico: ofrece orientaciones y soluciones prácticas, aplicables al área identificada para realizar mejoras, facilitando la implementación de estrategias que generen resultados tangibles.' },
      { id: 2, icon: 'fa-circle', texto: 'Capacitación y transferencia de conocimientos: brinda orientaciones técnicas a través de la información y apoyo técnico que se brinda a las instituciones, asegurando que los conocimientos adquiridos se mantengan y utilicen a largo plazo.' },     
    ];  
  return (

    <>
      <div className="regional-title">
        <div className="regional-block-title"></div>
        <h3>INAP - Investigación, Asesoria y Asistencia Técnica</h3>
      </div>
      <div className="regional-head-area container-fluid"></div>
      <style>{`
      .cardss{
      display:flex;
      flex-wrap: wrap;
      justify-content: center;
      }
        .regional-head-area {
          background-image: url(${bannerAseso});
          background-size: cover;
          background-position: center top;
          background-repeat: no-repeat;
          width: 100%;
          position: relative;
          background-color: #f5f5f5;
        }       
        @media (max-width: 549px) {
          .regional-head-area {
            height: 90px;
            background-size: contain;
          }
          .regional-title h3 {
            font-size: 16px;
          }
        }
        @media (min-width: 550px) and (max-width: 767px) {
          .regional-head-area {
            height: 130px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 18px;
          }
        }
        @media (min-width: 768px) and (max-width: 991px) {
          .regional-head-area {
            height: 170px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 20px;
          }
        }
        @media (min-width: 992px) and (max-width: 1199px) {
          .regional-head-area {
            height: 215px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 22px;
          }
        }
        @media (min-width: 1200px) and (max-width: 1990px) {
          .regional-head-area {
            height: 250px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 24px;
          }
        }
        @media (min-width: 1491px) {
          .regional-head-area {
            height: 260px;
            width: 100%;
          }
          .regional-title h3 {
            font-size: 26px;
          }
        }
      `}</style>
      {/* <RegionalBannerCentral/> */}
        {/*<AnchorTabsCategories />*/}
              <div className="portafolio_phome_area catalogo_servicios">
                <div className="portafolio_header">
                  {myBreadCrumbs2L("Asistencias Técnicas y Asosorías")}
                  <Botonera />
                  <FiltroCardsCursos />
                  <div className="buscador_area">
                    <BuscadorComponent />
                  </div>
                </div>
              </div>
      <Container className="asesorias-body-container">
        <Row>
          <Col>            
              <p>
                Los servicios de asesoría y asistencia técnica para el fortalecimiento de la gestión institucional del INAP, consisten en brindar a las instituciones
                públicas orientaciones, herramientas y competencias que permitan adoptar la gestión por resultados, como mecanismo para mejorar la prestación de sus servicios,
                 mediante la generación de una visión sectorial que le permita obtener mayores niveles de articulación, coordinación y sistematización de sus procesos sutantivos; 
                que en forma desconcentrada y automatizada, permitan prestar servicios efectivos a la población y contribuyan a generar cambios en sus condiciones de vida. 
              </p>   
              <p>Se caracteriza por:</p>      

            <ul className="list-asesoria">
                  {items.map((item) => (
                    <li key={item.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                      <i className={`fa ${item.icon}`} style={{ marginRight: '10px' }}></i>
                      {item.texto}
                    </li>
                  ))}
            </ul> 
           
            <div id="section0" className="portafolio_subcat first_section">
               <h2>Asistencias Técnicas y Asesorías</h2>
            </div>
           <br></br>  
           <div className="cardss">
           {BasicExample()}
           {BasicExample1()}
           {BasicExample2()}
           {BasicExample3()}

           </div>
               
          </Col>
        </Row>
        {/* {CATCursosStore.getCATCursosByCodigo.map((item: getCATCursos) => {
          })} */}

      </Container>
      <Container>
        <Row>
          <Col>        
            {/* <iframe
              className="mi-iframe"
              src={"https://inap.gob.gt/web/asesorias-y-asistencia-tecnia/"}
              allowFullScreen>
            </iframe> */}

          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
});
